// @ts-nocheck
/* eslint-disable */
import SceneMarker from "./marker";

export default class SceneMarkerGEO extends SceneMarker {
	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	get featureInfo() {
		return {
			name: "SceneMarkerGEO",
			type: "marker"
		};
	}

	/**
	 * Markeru se nastavi stav mouse over.
	 */
	mouseOver() {
		this._onChange(this._scene.featureEvent("markerMapyMouseOver", true, true), arguments);
	}

	/**
	 * Markeru se nastavi stav mouse out.
	 */
	mouseOut() {
		this._onChange(this._scene.featureEvent("markerMapyMouseOut", true, true), arguments);
	}
}
